var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c("div", { staticClass: "totalSumBlock flex justify-content-between" }, [
      _c("div", [
        _vm.invoice.status === 7
          ? _c("strong", [_vm._v("Приемка в процессе")])
          : _vm._e(),
      ]),
      _vm._v(" "),
      _c("div", {
        staticClass: "text-right",
        domProps: { innerHTML: _vm._s(_vm.totalFigures()) },
      }),
    ]),
    _vm._v(" "),
    _c("table", { staticClass: "table table-sm table-hover mt-1" }, [
      _c("thead", [
        _c(
          "tr",
          { staticClass: "sticky_tr" },
          [
            _c("th", { attrs: { width: "50px" } }),
            _vm._v(" "),
            _c("th", { attrs: { width: "50px" } }, [_vm._v("№")]),
            _vm._v(" "),
            _c("th", { attrs: { width: "50px" } }),
            _vm._v(" "),
            _vm.invoiceType === "income"
              ? _c("th", { attrs: { width: "50px" } }, [
                  _vm._v("Другая валюта"),
                ])
              : _vm._e(),
            _vm._v(" "),
            _c("th", { staticClass: "flex align-items-center" }, [
              _c(
                "div",
                { staticClass: "sorting_block" },
                [
                  _c(
                    "dropdown-menu",
                    {
                      attrs: { interactive: true, closeOnClickOutside: true },
                      model: {
                        value: _vm.showSortingDropDown,
                        callback: function ($$v) {
                          _vm.showSortingDropDown = $$v
                        },
                        expression: "showSortingDropDown",
                      },
                    },
                    [
                      _c("button", { staticClass: "btn btn-default mr-2" }, [
                        _vm._v("сортировка"),
                      ]),
                      _vm._v(" "),
                      _c(
                        "div",
                        { attrs: { slot: "dropdown" }, slot: "dropdown" },
                        [
                          _c(
                            "a",
                            {
                              staticClass: "dropdown-item pointer",
                              on: {
                                click: function ($event) {
                                  $event.preventDefault()
                                  return _vm.updateSort("enAlph")
                                },
                              },
                            },
                            [_vm._v("По EN алфавиту")]
                          ),
                          _vm._v(" "),
                          _c(
                            "a",
                            {
                              staticClass: "dropdown-item pointer",
                              on: {
                                click: function ($event) {
                                  $event.preventDefault()
                                  return _vm.updateSort("ruAlph")
                                },
                              },
                            },
                            [_vm._v("По алфавиту")]
                          ),
                          _vm._v(" "),
                          _c(
                            "a",
                            {
                              staticClass: "dropdown-item pointer",
                              on: {
                                click: function ($event) {
                                  $event.preventDefault()
                                  return _vm.updateSort("created")
                                },
                              },
                            },
                            [_vm._v("По добавлению")]
                          ),
                        ]
                      ),
                    ]
                  ),
                ],
                1
              ),
              _vm._v("\n        Препарат\n      "),
            ]),
            _vm._v(" "),
            _vm.showExpireDates || _vm.editExpireDates
              ? _c("th", { attrs: { width: "150px" } }, [
                  _vm._v("Сроки годности"),
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.moderateQty ? _c("th") : _vm._e(),
            _vm._v(" "),
            _c("th", [
              _vm._v("Кол" + _vm._s(_vm.transitInvoice ? "" : " заказ")),
            ]),
            _vm._v(" "),
            _vm.editQtyByFact
              ? [
                  _c("th", [_vm._v("Факт. кол.")]),
                  _vm._v(" "),
                  _c("th", [_vm._v("Остаток")]),
                ]
              : _vm._e(),
            _vm._v(" "),
            _c("th", [
              _vm._v(_vm._s(!_vm.editPrices ? "Себестоимость" : "Стоимость")),
            ]),
            _vm._v(" "),
            _c("th", [_vm._v("Сумма")]),
            _vm._v(" "),
            _vm.showDiscount
              ? [
                  _c("th", [_vm._v("Стоимость со скидкой")]),
                  _vm._v(" "),
                  _c("th", [_vm._v("Сумма со скидкой")]),
                ]
              : _vm._e(),
            _vm._v(" "),
            _vm.showExpensesPrice
              ? [
                  _c("th", [_vm._v("Стоимость с расходами")]),
                  _vm._v(" "),
                  _c("th", [_vm._v("Сумма")]),
                ]
              : _vm._e(),
            _vm._v(" "),
            _vm.showIntermediateSum ? _c("th") : _vm._e(),
            _vm._v(" "),
            _vm.showRemainStore ? _c("th", [_vm._v("Остаток")]) : _vm._e(),
            _vm._v(" "),
            _vm.displayDetails?.showExpiresDatesBefore?.show
              ? _c("th", [_vm._v("Сроки годности")])
              : _vm._e(),
          ],
          2
        ),
      ]),
      _vm._v(" "),
      _c(
        "tbody",
        [
          _vm._l(_vm.getFilteredRecords(), function (detail, index) {
            return [
              !detail.toDelete && !detail.searchHide
                ? _c(
                    "tr",
                    {
                      class: {
                        bg_success: _vm.hasDetailByAlias(
                          detail?.drug?.details ?? [],
                          "orderRates"
                        ),
                        mark: detail.selected,
                        no_en_title:
                          _vm.invoice.type === 4 &&
                          detail.drug?.id &&
                          !detail.drug.en_title,
                        storeMissing: _vm.isStoreMiss(detail),
                      },
                    },
                    [
                      _c("td", [
                        _c("p", { staticClass: "table_p" }, [
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: detail.selected,
                                expression: "detail.selected",
                              },
                            ],
                            staticClass: "w_50p",
                            attrs: { type: "checkbox" },
                            domProps: {
                              checked: Array.isArray(detail.selected)
                                ? _vm._i(detail.selected, null) > -1
                                : detail.selected,
                            },
                            on: {
                              change: function ($event) {
                                var $$a = detail.selected,
                                  $$el = $event.target,
                                  $$c = $$el.checked ? true : false
                                if (Array.isArray($$a)) {
                                  var $$v = null,
                                    $$i = _vm._i($$a, $$v)
                                  if ($$el.checked) {
                                    $$i < 0 &&
                                      _vm.$set(
                                        detail,
                                        "selected",
                                        $$a.concat([$$v])
                                      )
                                  } else {
                                    $$i > -1 &&
                                      _vm.$set(
                                        detail,
                                        "selected",
                                        $$a
                                          .slice(0, $$i)
                                          .concat($$a.slice($$i + 1))
                                      )
                                  }
                                } else {
                                  _vm.$set(detail, "selected", $$c)
                                }
                              },
                            },
                          }),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c("td", [
                        _c("p", { staticClass: "table_p" }, [
                          _vm._v(_vm._s(index + 1)),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c(
                        "td",
                        [
                          detail.drug
                            ? [
                                _c("DetailCommentBlock", {
                                  attrs: {
                                    invoice: _vm.invoice,
                                    detail: detail,
                                    updateRecord: (r) =>
                                      (_vm.detailList[index] = {
                                        ..._vm.detailList[index],
                                        ...r,
                                      }),
                                  },
                                }),
                              ]
                            : _vm._e(),
                        ],
                        2
                      ),
                      _vm._v(" "),
                      _vm.invoiceType === "income"
                        ? _c("td", [
                            _c("p", { staticClass: "table_p" }, [
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: detail.anyCurrency,
                                    expression: "detail.anyCurrency",
                                  },
                                ],
                                staticClass: "w_50p",
                                attrs: { type: "checkbox" },
                                domProps: {
                                  checked: Array.isArray(detail.anyCurrency)
                                    ? _vm._i(detail.anyCurrency, null) > -1
                                    : detail.anyCurrency,
                                },
                                on: {
                                  change: function ($event) {
                                    var $$a = detail.anyCurrency,
                                      $$el = $event.target,
                                      $$c = $$el.checked ? true : false
                                    if (Array.isArray($$a)) {
                                      var $$v = null,
                                        $$i = _vm._i($$a, $$v)
                                      if ($$el.checked) {
                                        $$i < 0 &&
                                          _vm.$set(
                                            detail,
                                            "anyCurrency",
                                            $$a.concat([$$v])
                                          )
                                      } else {
                                        $$i > -1 &&
                                          _vm.$set(
                                            detail,
                                            "anyCurrency",
                                            $$a
                                              .slice(0, $$i)
                                              .concat($$a.slice($$i + 1))
                                          )
                                      }
                                    } else {
                                      _vm.$set(detail, "anyCurrency", $$c)
                                    }
                                  },
                                },
                              }),
                            ]),
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _c(
                        "td",
                        [
                          _vm.disableEdit && !_vm.allowToEdit[detail?.drug?.id]
                            ? [
                                _c("div", { staticClass: "input-group" }, [
                                  _c("input", {
                                    staticClass: "form-control",
                                    attrs: { disabled: "", type: "text" },
                                    domProps: { value: detail?.drug?.title },
                                  }),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    { staticClass: "input-group-append" },
                                    [
                                      _c(
                                        "button",
                                        {
                                          staticClass: "btn btn-sm btn-info",
                                          on: {
                                            click: function ($event) {
                                              return _vm.updateAllowEdit(
                                                detail?.drug?.id
                                              )
                                            },
                                          },
                                        },
                                        [
                                          _c("i", {
                                            staticClass: "icon-fa icon-fa-edit",
                                          }),
                                        ]
                                      ),
                                    ]
                                  ),
                                ]),
                              ]
                            : [
                                _c("DrugSearchNew", {
                                  ref: `search_drug_${index}`,
                                  refInFor: true,
                                  attrs: {
                                    selectedDrug: detail.drug,
                                    searchOptions: {
                                      currencyId:
                                        _vm.invoiceType === "income"
                                          ? !detail.anyCurrency
                                            ? _vm.invoice.currency_id
                                            : false
                                          : false,
                                    },
                                    onSelect: (d) =>
                                      _vm.addDrug(index, detail?.drug?.id, d),
                                  },
                                }),
                              ],
                          _vm._v(" "),
                          _c(
                            "div",
                            [
                              detail?.drug?.id
                                ? _c("p", [
                                    _vm._v(
                                      "ENG: " +
                                        _vm._s(_vm.getEnTitle(detail.drug))
                                    ),
                                  ])
                                : _vm._e(),
                              _vm._v(" "),
                              _c("DetailsView", {
                                attrs: {
                                  drug: detail?.drug,
                                  details: detail?.drug?.details ?? [],
                                },
                              }),
                              _vm._v(" "),
                              (detail.extra_data?.selected_expire_dates ?? [])
                                .length
                                ? _c("div", [
                                    _c("i", [
                                      _vm._v("Указаны сроки годности:"),
                                    ]),
                                    _vm._v(" "),
                                    _c(
                                      "strong",
                                      _vm._l(
                                        detail.extra_data.selected_expire_dates,
                                        function (d, i) {
                                          return _c("span", [
                                            _vm._v(
                                              _vm._s(i !== 0 ? ", " : "") +
                                                _vm._s(d.date)
                                            ),
                                          ])
                                        }
                                      ),
                                      0
                                    ),
                                  ])
                                : _vm._e(),
                            ],
                            1
                          ),
                        ],
                        2
                      ),
                      _vm._v(" "),
                      _vm.showExpireDates || _vm.editExpireDates
                        ? _c(
                            "td",
                            [
                              _c("ExpireDatesByMask", {
                                attrs: {
                                  allToSelectDate: true,
                                  disableEdit: true,
                                  invoiceId: _vm.invoice.id,
                                  updateDates: (d) => {},
                                  "drug-id": detail.drug_id,
                                  savedDates: _vm.getSavedExpireDates(detail),
                                  expireDates:
                                    _vm.drugExpireDates[detail.drug_id],
                                },
                              }),
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.moderateQty
                        ? _c(
                            "td",
                            [
                              detail.drug?.id &&
                              detail.income_qty !== null &&
                              detail.qty !== detail.income_qty
                                ? [
                                    _c(
                                      "div",
                                      {
                                        staticClass: "input-group moderate_qty",
                                      },
                                      [
                                        _c("input", {
                                          directives: [
                                            {
                                              name: "model",
                                              rawName: "v-model",
                                              value: detail.income_qty,
                                              expression: "detail.income_qty",
                                            },
                                          ],
                                          staticClass: "form-control",
                                          attrs: { type: "text", disabled: "" },
                                          domProps: {
                                            value: detail.income_qty,
                                          },
                                          on: {
                                            input: function ($event) {
                                              if ($event.target.composing)
                                                return
                                              _vm.$set(
                                                detail,
                                                "income_qty",
                                                $event.target.value
                                              )
                                            },
                                          },
                                        }),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "input-group-append flex",
                                          },
                                          [
                                            _c(
                                              "button",
                                              {
                                                staticClass:
                                                  "btn btn-outline-success",
                                                attrs: { type: "button" },
                                                on: {
                                                  click: function ($event) {
                                                    return _vm.updateIncomeQty(
                                                      detail
                                                    )
                                                  },
                                                },
                                              },
                                              [
                                                _c("i", {
                                                  staticClass:
                                                    "icon-fa icon-fa-check",
                                                }),
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "button",
                                              {
                                                staticClass:
                                                  "btn btn-outline-danger",
                                                attrs: { type: "button" },
                                                on: {
                                                  click: function ($event) {
                                                    return _vm.updateIncomeQty(
                                                      detail,
                                                      true
                                                    )
                                                  },
                                                },
                                              },
                                              [
                                                _c("i", {
                                                  staticClass:
                                                    "icon-fa icon-fa-close",
                                                }),
                                              ]
                                            ),
                                          ]
                                        ),
                                      ]
                                    ),
                                  ]
                                : _vm._e(),
                            ],
                            2
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _c("td", [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: detail.qty,
                              expression: "detail.qty",
                            },
                          ],
                          staticClass: "form-control",
                          attrs: {
                            disabled:
                              (_vm.disableEdit || _vm.editQtyByFact) &&
                              !_vm.allowToEdit[detail?.drug?.id],
                            type: "number",
                          },
                          domProps: { value: detail.qty },
                          on: {
                            input: function ($event) {
                              if ($event.target.composing) return
                              _vm.$set(detail, "qty", $event.target.value)
                            },
                          },
                        }),
                      ]),
                      _vm._v(" "),
                      _vm.editQtyByFact
                        ? [
                            _c(
                              "td",
                              [
                                detail?.drug?.detail
                                  ? [
                                      _c(
                                        "v-popover",
                                        {
                                          attrs: {
                                            "auto-hide": true,
                                            placement: "bottom",
                                            open: _vm.confirmRateTooltip[
                                              detail.drug.id
                                            ],
                                          },
                                          on: {
                                            hide: () =>
                                              (_vm.confirmRateTooltip[
                                                detail.id
                                              ] = false),
                                          },
                                        },
                                        [
                                          _c("input", {
                                            directives: [
                                              {
                                                name: "model",
                                                rawName: "v-model",
                                                value: detail.income_qty,
                                                expression: "detail.income_qty",
                                              },
                                            ],
                                            staticClass:
                                              "form-control qty_by_fact",
                                            attrs: { type: "number" },
                                            domProps: {
                                              value: detail.income_qty,
                                            },
                                            on: {
                                              keyup: (event) =>
                                                _vm.shiftFocus(
                                                  event,
                                                  index,
                                                  detail.drug.id
                                                ),
                                              change: function ($event) {
                                                return _vm.updateRemainQty(
                                                  detail.drug.id
                                                )
                                              },
                                              input: function ($event) {
                                                if ($event.target.composing)
                                                  return
                                                _vm.$set(
                                                  detail,
                                                  "income_qty",
                                                  $event.target.value
                                                )
                                              },
                                            },
                                          }),
                                          _vm._v(" "),
                                          _c("template", { slot: "popover" }, [
                                            _c("p", [
                                              _vm._v(
                                                "Препарат заказывается по коэффициенту"
                                              ),
                                            ]),
                                            _vm._v(" "),
                                            _c("p", [
                                              _vm._v("Выберите количество"),
                                            ]),
                                            _vm._v(" "),
                                            _c("div", { staticClass: "flex" }, [
                                              _c(
                                                "button",
                                                {
                                                  staticClass:
                                                    "btn btn-default",
                                                  on: {
                                                    click: function ($event) {
                                                      _vm.confirmRateTooltip[
                                                        detail.id
                                                      ] = false
                                                    },
                                                  },
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(detail.income_qty) +
                                                      "\n                    "
                                                  ),
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "button",
                                                {
                                                  staticClass:
                                                    "btn btn-default ml-2",
                                                  on: {
                                                    click: function ($event) {
                                                      detail.income_qty =
                                                        detail.income_qty *
                                                        +detail.drug.detail
                                                          .int_value
                                                      _vm.confirmRateTooltip[
                                                        detail.id
                                                      ] = false
                                                    },
                                                  },
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      detail.income_qty *
                                                        +detail.drug.detail
                                                          .int_value
                                                    ) + "\n                    "
                                                  ),
                                                ]
                                              ),
                                            ]),
                                          ]),
                                        ],
                                        2
                                      ),
                                    ]
                                  : [
                                      _c("input", {
                                        directives: [
                                          {
                                            name: "model",
                                            rawName: "v-model",
                                            value: detail.income_qty,
                                            expression: "detail.income_qty",
                                          },
                                        ],
                                        staticClass: "form-control qty_by_fact",
                                        attrs: { type: "number" },
                                        domProps: { value: detail.income_qty },
                                        on: {
                                          keyup: (event) =>
                                            _vm.shiftFocus(event, index),
                                          change: function ($event) {
                                            return _vm.updateRemainQty(
                                              detail.drug.id
                                            )
                                          },
                                          input: function ($event) {
                                            if ($event.target.composing) return
                                            _vm.$set(
                                              detail,
                                              "income_qty",
                                              $event.target.value
                                            )
                                          },
                                        },
                                      }),
                                    ],
                              ],
                              2
                            ),
                            _vm._v(" "),
                            _c("td", [
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: detail.remain_qty,
                                    expression: "detail.remain_qty",
                                  },
                                ],
                                staticClass: "form-control",
                                attrs: { type: "number" },
                                domProps: { value: detail.remain_qty },
                                on: {
                                  input: function ($event) {
                                    if ($event.target.composing) return
                                    _vm.$set(
                                      detail,
                                      "remain_qty",
                                      $event.target.value
                                    )
                                  },
                                },
                              }),
                            ]),
                          ]
                        : _vm._e(),
                      _vm._v(" "),
                      _c(
                        "td",
                        [
                          _vm.editPrices
                            ? [
                                _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: detail.income_price,
                                      expression: "detail.income_price",
                                    },
                                  ],
                                  staticClass: "form-control",
                                  attrs: {
                                    type: "number",
                                    disabled:
                                      _vm.disableEdit &&
                                      !_vm.allowToEdit[detail?.drug?.id],
                                  },
                                  domProps: { value: detail.income_price },
                                  on: {
                                    change: () => _vm.getRecords(false),
                                    input: function ($event) {
                                      if ($event.target.composing) return
                                      _vm.$set(
                                        detail,
                                        "income_price",
                                        $event.target.value
                                      )
                                    },
                                  },
                                }),
                              ]
                            : [
                                _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: detail.cost_price,
                                      expression: "detail.cost_price",
                                    },
                                  ],
                                  staticClass: "form-control",
                                  attrs: { type: "number", disabled: "" },
                                  domProps: { value: detail.cost_price },
                                  on: {
                                    input: function ($event) {
                                      if ($event.target.composing) return
                                      _vm.$set(
                                        detail,
                                        "cost_price",
                                        $event.target.value
                                      )
                                    },
                                  },
                                }),
                              ],
                        ],
                        2
                      ),
                      _vm._v(" "),
                      _c("td", [
                        _c("p", { staticClass: "table_p" }, [
                          _vm._v(
                            _vm._s(
                              Math.round(
                                +detail.qty *
                                  (_vm.transitInvoice
                                    ? +detail.cost_price
                                    : +detail.income_price) *
                                  1000
                              ) / 1000
                            )
                          ),
                        ]),
                      ]),
                      _vm._v(" "),
                      _vm.showDiscount
                        ? [
                            _c("td", [
                              _c("p", { staticClass: "table_p" }, [
                                _vm._v(_vm._s(detail.price || 0)),
                              ]),
                            ]),
                            _vm._v(" "),
                            _c("td", [
                              _c("p", { staticClass: "table_p" }, [
                                _vm._v(
                                  _vm._s(
                                    Math.round(
                                      (detail.price || 0) *
                                        (+detail.qty || 0) *
                                        1000
                                    ) / 1000
                                  )
                                ),
                              ]),
                            ]),
                          ]
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.showExpensesPrice
                        ? [
                            _c("td", [
                              _c("p", { staticClass: "table_p" }, [
                                _vm._v(_vm._s(detail.price_w_expense || 0)),
                              ]),
                            ]),
                            _vm._v(" "),
                            _c("td", [
                              _c("p", { staticClass: "table_p" }, [
                                _vm._v(
                                  _vm._s(
                                    Math.round(
                                      (detail.price_w_expense || 0) *
                                        (+detail.qty || 0) *
                                        1000
                                    ) / 1000
                                  )
                                ),
                              ]),
                            ]),
                          ]
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.showIntermediateSum
                        ? _c("td", [
                            _c("p", { staticClass: "table_p" }, [
                              _vm._v(_vm._s(_vm.getIntermSumByIndex(index))),
                            ]),
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.showRemainStore
                        ? _c("td", [
                            _c("p", { staticClass: "table_p" }, [
                              _vm._v(
                                "\n            " +
                                  _vm._s(
                                    detail?.drug?.id &&
                                      _vm.storeRemain[detail.drug.id] &&
                                      _vm.storeRemain[detail.drug.id][
                                        _vm.invoice.store_out
                                      ]
                                  )
                              ),
                            ]),
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.displayDetails?.showExpiresDatesBefore?.show
                        ? _c(
                            "td",
                            { staticClass: "pl-2" },
                            _vm._l(
                              _vm.sortArray(
                                detail.drug?.valid_dates ?? [],
                                "expire_date"
                              ),
                              function (d) {
                                return d.is_active
                                  ? _c("p", [
                                      _vm._v(
                                        "\n            " +
                                          _vm._s(
                                            _vm.printDate(
                                              d.expire_date,
                                              "DD.MM.YYYY"
                                            )
                                          )
                                      ),
                                    ])
                                  : _vm._e()
                              }
                            ),
                            0
                          )
                        : _vm._e(),
                    ],
                    2
                  )
                : _vm._e(),
            ]
          }),
        ],
        2
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }